(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-offer-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pth-offer-selector')) {
  customElements.define('pth-offer-selector', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.busy = false;
      this._events = new AbortController();
      this.cardButton = this.querySelector('[data-action="card"]');
      this.codButton = this.querySelector('[data-action="cod"]');
      this.status = this.querySelector('.pth-offer__status');
      this.easySellProxy = this.querySelector('[data-easysell-proxy]');
      this.promoCycleIndicator = this.querySelector('[data-pth-promo-cycle]');
      this.currentProductId = Number(this.dataset.currentProductId);
      this.createEasySellForm();
      this.querySelectorAll('[data-offer-radio], [data-bottle-color]').forEach(control => {
        control.addEventListener('change', () => this.sync(), { signal: this._events.signal });
      });
      this.cardButton?.addEventListener('click', () => this.purchase('card'), { signal: this._events.signal });
      this.codButton?.addEventListener('click', () => this.purchase('cod'), { signal: this._events.signal });
      this._externalClick = event => {
        if (!(event.target instanceof Element) || this.busy) return;
        const trigger = event.target.closest('button, a, [role="button"], input[type="button"], input[type="submit"]');
        if (!trigger || this.contains(trigger) || trigger.closest('#easysell-modal, cart-drawer, #CartDrawer, #cart-drawer, .cart-drawer')) return;
        if (!trigger.matches('[class*="es-popup-button"], [class*="easysell"]')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.purchase('cod');
      };
      window.addEventListener('click', this._externalClick, true);
      const requested = new URLSearchParams(window.location.search).get('pth_offer');
      const radio = Array.from(this.querySelectorAll('[data-offer-radio]')).find(item => item.value === requested);
      if (radio) radio.checked = true;
      this.sync();
      this.startOfferCountdown();
      if (this.promoCycleIndicator) {
        this.updatePromoCycleIndicator();
        // Solo actualiza un indicador ciclico de la promocion; nunca lee inventario.
        this._promoCycleInterval = setInterval(() => this.updatePromoCycleIndicator(), 15 * 1000);
      }
    }

    disconnectedCallback() {
      this._events?.abort();
      clearInterval(this._countdownInterval);
      clearInterval(this._promoCycleInterval);
      window.removeEventListener('click', this._externalClick, true);
      if (this.easySellForm) {
        if (this.easySellProxy) this.querySelector('.pth-offer__actions')?.appendChild(this.easySellProxy);
        this.easySellForm.remove();
        this.easySellForm = null;
      }
      this._ready = false;
    }

    startOfferCountdown() {
      clearInterval(this._countdownInterval);
      const timer = this.querySelector('[data-countdown]');
      const promo = this.querySelector('[data-exclusive-promo]');
      const label = this.querySelector('[data-countdown-label]');
      if (!timer || !promo) return;
      const isLoop = timer.dataset.loop === 'true';
      const cycleSeconds = Math.max(1, Number(timer.dataset.cycleHours) || 2) * 3600;
      const initialNow = Date.now();
      const storageKey = `pth-countdown:${this.dataset.selectorKey}:${cycleSeconds}:${isLoop}`;
      let startTime = initialNow;
      try {
        const storedStart = Number(window.localStorage.getItem(storageKey));
        if (Number.isFinite(storedStart) && storedStart > 0 && storedStart <= initialNow) {
          startTime = storedStart;
        } else {
          window.localStorage.setItem(storageKey, String(startTime));
        }
      } catch (_) {
        startTime = this._countdownStart || initialNow;
        this._countdownStart = startTime;
      }
      const update = () => {
        const elapsed = Math.max(0, Math.floor((Date.now() - startTime) / 1000));
        const remaining = isLoop
          ? cycleSeconds - (elapsed % cycleSeconds)
          : Math.max(0, cycleSeconds - elapsed);
        if (remaining === 0) {
          promo.hidden = true;
          clearInterval(this._countdownInterval);
          return false;
        }
        const values = { hours: Math.floor(remaining / 3600), minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
        for (const [unit, value] of Object.entries(values)) {
          const cell = timer.querySelector(`[data-${unit}]`);
          if (cell) cell.textContent = String(value).padStart(2, '0');
        }
        promo.hidden = false;
        timer.hidden = false;
        if (label) label.hidden = false;
        return true;
      };
      if (update()) this._countdownInterval = setInterval(update, 1000);
    }

    createEasySellForm() {
      if (!this.easySellProxy || this.easySellForm) return;
      const root = window.Shopify?.routes?.root || '/';
      const form = document.createElement('form');
      form.method = 'post';
      form.action = `${root}cart/add`;
      form.hidden = true;
      form.dataset.pthEasysellForm = this.dataset.selectorKey;
      for (const [name, value] of [
        ['form_type', 'product'], ['id', ''], ['quantity', '1'],
        ['properties[_pth_selector]', this.dataset.selectorKey], ['properties[_pth_offer]', '1']
      ]) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
      }
      form.appendChild(this.easySellProxy);
      document.body.appendChild(form);
      this.easySellForm = form;
    }

    // Indicador promocional independiente de Shopify. Su valor representa
    // una fase visual del ciclo, NO la cantidad de productos disponibles.
    updatePromoCycleIndicator() {
      const indicator = this.promoCycleIndicator;
      if (!indicator) return;
      const start = Math.max(1, Math.round(Number(indicator.dataset.start) || 16));
      const minimum = Math.min(start, Math.max(0, Math.round(Number(indicator.dataset.minimum) || 0)));
      const stepMs = Math.max(1, Number(indicator.dataset.stepMinutes) || 30) * 60 * 1000;
      const cycleMs = Math.max(1, Number(indicator.dataset.cycleHours) || 6) * 60 * 60 * 1000;
      const elapsedInCycle = ((Date.now() % cycleMs) + cycleMs) % cycleMs;
      const numberOfSteps = Math.floor(elapsedInCycle / stepMs);
      const value = Math.max(minimum, start - numberOfSteps);
      const output = indicator.querySelector('[data-pth-promo-value]');
      if (output) output.textContent = String(value);
    }

    selectedState(index) {
      const selected = index
        ? this.querySelector(`[data-offer-radio][data-offer-index="${index}"]`)
        : this.querySelector('[data-offer-radio]:checked');
      const offerIndex = selected?.dataset.offerIndex || '';
      const controls = Array.from(this.querySelectorAll(`[data-bottle-color][data-offer="${offerIndex}"]`));
      const groups = new Map();
      let price = 0;
      let compare = 0;
      let available = Boolean(selected && controls.length === Number(selected.dataset.unitCount || offerIndex));
      for (const control of controls) {
        const option = control.selectedOptions[0];
        const id = Number(option?.value || 0);
        if (!id || option?.dataset.available !== 'true') available = false;
        if (!id) continue;
        price += Number(option.dataset.price || 0);
        compare += Math.max(Number(option.dataset.compare || 0), Number(option.dataset.price || 0));
        const item = groups.get(id) || { id, quantity: 0, productId: Number(option.dataset.productId), stock: Number(option.dataset.inventory), tracked: option.dataset.track === 'true' };
        item.quantity += 1;
        groups.set(id, item);
      }
      const grouped = Array.from(groups.values());
      if (grouped.some(item => item.tracked && item.quantity > item.stock)) available = false;
      const fixedPrice = Number(selected?.dataset.fixedPrice || 0);
      if (grouped.length && Number.isFinite(fixedPrice) && fixedPrice > 0) price = Math.round(fixedPrice);
      return { selected, offerIndex, available, price, compare,
        items: grouped.map(({ id, quantity }) => ({ id, quantity })), grouped };
    }

    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {
        style: 'currency', currency: this.dataset.currency || 'EUR'
      }).format(cents / 100);
    }

    moneySaving(cents) {
      const hasDecimals = Math.abs(cents) % 100 !== 0;
      return new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {
        style: 'currency', currency: this.dataset.currency || 'EUR',
        minimumFractionDigits: hasDecimals ? 2 : 0, maximumFractionDigits: 2
      }).format(cents / 100);
    }

    sync() {
      const state = this.selectedState();
      this.classList.toggle('is-multi-offer', Number(state.offerIndex) > 1);
      this.querySelectorAll('[data-color-panel]').forEach(panel => {
        panel.hidden = panel.dataset.pickerEnabled !== 'true' || panel.dataset.colorPanel !== state.offerIndex;
      });
      this.querySelectorAll('[data-offer-radio]').forEach(radio => {
        const offer = this.selectedState(radio.dataset.offerIndex);
        const price = this.querySelector(`[data-offer-price="${offer.offerIndex}"]`);
        const compare = this.querySelector(`[data-offer-compare="${offer.offerIndex}"]`);
        const saving = this.querySelector(`[data-offer-saving="${offer.offerIndex}"]`);
        if (price) price.textContent = offer.items.length ? this.money(offer.price) : '';
        if (compare) {
          compare.hidden = offer.compare <= offer.price;
          compare.textContent = offer.compare > offer.price ? this.money(offer.compare) : '';
        }
        if (saving && saving.dataset.mode !== 'manual') {
          const amount = offer.compare - offer.price;
          saving.hidden = !offer.items.length || amount <= 0;
          if (amount > 0) saving.textContent = `${saving.dataset.prefix || 'Ahorra'} ${this.moneySaving(amount)}`;
        }
        this.querySelector(`[data-offer-card="${offer.offerIndex}"]`)?.classList.toggle('is-unavailable', !offer.available);
      });
      for (const button of [this.cardButton, this.codButton]) {
        if (button) button.disabled = this.busy || !state.available;
      }
      if (this.status && !this.busy) {
        this.status.textContent = !state.items.length
          ? 'Selecciona el producto de esta oferta en el editor de Shopify.'
          : !state.available ? 'No hay stock suficiente para esta selección de variantes.' : '';
      }
      this.syncProductForms(state);
      this.dispatchEvent(new CustomEvent('pth:offer-change', { bubbles: true, detail: { offerIndex: state.offerIndex, items: state.items, available: state.available } }));
    }

    syncProductForms(state) {
      if (state.grouped.length !== 1 || state.grouped[0].productId !== this.currentProductId) return;
      const scope = this.closest('product-info') || this.closest('.main-product-section') || this.closest('.shopify-section');
      const forms = new Set(scope?.querySelectorAll('form[action*="/cart/add"]') || []);
      if (this.easySellForm) forms.add(this.easySellForm);
      for (const form of forms) {
        const id = form.querySelector('[name="id"]');
        let quantity = form.querySelector('[name="quantity"]');
        if (!quantity) {
          quantity = document.createElement('input');
          quantity.type = 'hidden';
          quantity.name = 'quantity';
          form.appendChild(quantity);
        }
        if (id) {
          id.value = String(state.items[0].id);
          if (id instanceof HTMLInputElement) id.setAttribute('value', id.value);
        }
        quantity.value = String(state.items[0].quantity);
        if (quantity instanceof HTMLInputElement) quantity.setAttribute('value', quantity.value);
        const offer = form.querySelector('[name="properties[_pth_offer]"]');
        if (offer) offer.value = state.offerIndex;
      }
    }

    openEasySell(state) {
      this.syncProductForms(state);
      const quantity = String(state.items[0].quantity);
      document.querySelectorAll('[name="es-quantity-picker"]').forEach(input => {
        input.value = quantity;
        input.setAttribute('value', quantity);
      });
      if (typeof window.openTysloForm === 'function') {
        window.ES_CLOSEST_FORM = this.easySellForm;
        return window.openTysloForm();
      } else {
        this.easySellProxy.click();
      }
    }

    async cartRequest(path, payload) {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}${path}`, {
        method: payload ? 'POST' : 'GET',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        ...(payload ? { body: JSON.stringify(payload) } : {})
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'No se pudo actualizar el carrito.');
      return result;
    }

    async prepareCart(state) {
      const cart = await this.cartRequest('cart.js');
      const updates = {};
      for (const item of cart.items || []) {
        if (item.properties?._pth_selector === this.dataset.selectorKey) updates[item.key] = 0;
      }
      if (Object.keys(updates).length) await this.cartRequest('cart/update.js', { updates });
      return this.cartRequest('cart/add.js', { items: state.items.map(item => ({ ...item,
        properties: { _pth_selector: this.dataset.selectorKey, _pth_offer: state.offerIndex }
      })) });
    }

    async purchase(method) {
      const state = this.selectedState();
      if (this.busy || !state.available) return;
      this.busy = true;
      this.sync();
      const button = method === 'card' ? this.cardButton : this.codButton;
      button?.setAttribute('aria-busy', 'true');
      if (this.status) this.status.textContent = '';
      const root = window.Shopify?.routes?.root || '/';
      try {
        if (method === 'cod' && state.grouped.length === 1 && state.grouped[0].productId === this.currentProductId && this.easySellProxy) {
          await this.openEasySell(state);
        } else {
          await this.prepareCart(state);
          if (method === 'card') {
            window.location.assign(`${root}checkout`);
          } else {
            const cartButton = document.querySelector('cart-drawer [class*="es-popup-button"], #CartDrawer [class*="es-popup-button"], #cart-drawer [class*="es-popup-button"], .cart-drawer [class*="es-popup-button"], .es-popup-button-cart');
            if (cartButton) cartButton.click();
            else window.location.assign(`${root}cart`);
          }
        }
      } catch (error) {
        if (this.status) this.status.textContent = error.message || 'No se pudo preparar el pedido. Inténtalo de nuevo.';
      } finally {
        this.busy = false;
        button?.removeAttribute('aria-busy');
        for (const control of [this.cardButton, this.codButton]) {
          if (control) control.disabled = !this.selectedState().available;
        }
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product_shipping-checkpoints"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pth-shipping-summary')) {
  customElements.define('pth-shipping-summary', class extends HTMLElement {
    connectedCallback() {
      this._initialFrame = requestAnimationFrame(() => this.refreshDates());
      this._dateReady = () => this.refreshDates();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this._dateReady, { once: true });
      clearInterval(this._dateInterval);
      this._dateInterval = setInterval(() => this.refreshDates(), 60000);
    }
    disconnectedCallback() {
      clearInterval(this._dateInterval);
      cancelAnimationFrame(this._initialFrame);
      document.removeEventListener('DOMContentLoaded', this._dateReady);
    }
    today() {
      let parts;
      try {
        parts = new Intl.DateTimeFormat('en-CA', { timeZone: this.dataset.timezone || 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      } catch (_) {
        parts = new Intl.DateTimeFormat('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      }
      const value = type => Number(parts.find(part => part.type === type).value);
      return new Date(Date.UTC(value('year'), value('month') - 1, value('day'), 12));
    }
    addDays(base, amount) {
      const date = new Date(base.getTime());
      let remaining = Math.max(0, Math.min(365, Math.floor(Number(amount) || 0)));
      while (remaining > 0) {
        date.setUTCDate(date.getUTCDate() + 1);
        const weekday = date.getUTCDay();
        remaining -= 1;
      }
      return date;
    }
    formatDate(date) {
      const weekday = date.getUTCDay(), day = date.getUTCDate(), month = date.getUTCMonth();
      const compact = this.dataset.compact === 'true';
      const days = (this.dataset.daysLabels || 'Lun, Mar, Mié, Jue, Vie, Sáb, Dom').split(',').map(value => value.trim());
      const months = (this.dataset.monthsLabels || 'ene, feb, mar, abr, may, jun, jul, ago, sept, oct, nov, dic').split(',').map(value => value.trim());
      const dayLabel = days[(weekday + 6) % 7] || '';
      const monthLabel = months[month] || String(month + 1);
      if (compact) return `${dayLabel}, ${day} ${monthLabel}`;
      const paddedDay = String(day).padStart(2, '0'), paddedMonth = String(month + 1).padStart(2, '0');
      switch (this.dataset.dateFormat) {
        case 'day_mm_dd': return `${dayLabel}, ${monthLabel} ${day}`;
        case 'day_dd_mm': return `${dayLabel}, ${day}. ${monthLabel}`;
        case 'mm_dd': return `${monthLabel} ${day}`;
        case 'dd_mm': return `${day}. ${monthLabel}`;
        case 'day_dd_mm_numeric': return `${dayLabel}, ${paddedDay}/${paddedMonth}`;
        case 'dd_mm_numeric': return `${paddedDay}/${paddedMonth}`;
        default: return `${day} ${monthLabel}`;
      }
    }
    fillTemplate(element, attribute, start, end) {
      const template = element.dataset[attribute] || '';
      if (element._lastTemplate === template && element._lastStart === start && element._lastEnd === end) return;
      element.innerHTML = template;
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      for (const node of nodes) node.textContent = node.textContent.replaceAll('[start_date]', start).replaceAll('[end_date]', end);
      element._lastTemplate = template;
      element._lastStart = start;
      element._lastEnd = end;
    }
    refreshDates() {
      const delivery = this.querySelector('[data-delivery-template]');
      const card = this.querySelector('.pth-shipping__delivery');
      if (!delivery || !card) return;
      const base = this.today();
      const min = Math.max(0, Number(card.dataset.minDays) || 0);
      const max = Math.max(min, Number(card.dataset.maxDays) || min);
      this.fillTemplate(delivery, 'deliveryTemplate', this.formatDate(this.addDays(base, min)), this.formatDate(this.addDays(base, max)));
    }

  });
}
  } catch(e) { console.error(e); }
})();

})();
